import React from 'react';
import moment from 'moment';
// Helpers
import { parseForInnerHTML } from 'helpers/textEditor';
import { formatCurrencyString } from 'helpers/utils';
// Types
import {
  GetCampaignsV2_getCampaigns_entities,
  GetCampaignsV2_getCampaigns_entities_activities_EventMarketingActivity,
} from 'api/campaignV2/types/GetCampaignsV2';
// Styles
import styles from './EventMarketingDetailsModal.module.scss';

type EventMarketingDetailsModalProps = {
  record: GetCampaignsV2_getCampaigns_entities;
};

const EventMarketingDetailsModal = ({
  record,
}: EventMarketingDetailsModalProps): JSX.Element => {
  const activity = record
    .activities?.[0] as GetCampaignsV2_getCampaigns_entities_activities_EventMarketingActivity;

  const campaignOwner = `${record?.agency?.firstName || ''} ${
    record?.agency?.lastName || ''
  }`;

  return (
    <div className={styles.root}>
      <div className={styles.recordData}>
        <div>
          <p className={styles.label}>ID:</p>
          <p className={styles.value}>{record.id}</p>
        </div>

        <div>
          <p className={styles.label}>Company Name:</p>
          <p className={styles.value}>{record.name}</p>
        </div>

        <div>
          <p className={styles.label}>Campaign Owner:</p>
          <p className={styles.value}>{campaignOwner}</p>
        </div>

        {record?.estimatedBudget ? (
          <div>
            <p className={styles.label}>Cost:</p>
            <p className={styles.value}>
              {formatCurrencyString(record?.estimatedBudget)}
            </p>
          </div>
        ) : (
          <></>
        )}

        {record?.budget ? (
          <div>
            <p className={styles.label}>Total Paid Budget:</p>
            <p className={styles.value}>
              {formatCurrencyString(record?.budget)}
            </p>
          </div>
        ) : (
          <></>
        )}

        <div>
          <p className={styles.label}>Event date and time:</p>
          <p className={styles.value}>
            {activity.startDate
              ? moment(activity.startDate).format('M/D/YYYY, h:mm A')
              : 'N/a'}
          </p>
        </div>

        <div>
          <p className={styles.label}>Sport:</p>
          {activity.sport ? (
            <p className={styles.value}>{activity.sport}</p>
          ) : (
            <p className={styles.value}>N/a</p>
          )}
        </div>

        <div>
          <p className={styles.label}>Number of Interviews:</p>
          <p className={styles.value}>{activity.participantCount} Interviews</p>
        </div>

        {activity.description && (
          <div>
            <p className={styles.label}>Description/Instructions:</p>
            <p
              className={styles.value}
              dangerouslySetInnerHTML={{
                __html: parseForInnerHTML(activity?.description ?? 'N/a'),
              }}
            />
          </div>
        )}

        <div>
          <p className={styles.label}>Your Website & Socials:</p>
          {activity.socialMediaLinks?.length ? (
            activity.socialMediaLinks.map((link) => (
              <p className={styles.value} key={link}>
                <a href={link} target="_blank" rel="noopener noreferrer">
                  {link}
                </a>
              </p>
            ))
          ) : (
            <p className={styles.value}>No links provided</p>
          )}
        </div>
        <div>
          <p className={styles.label}>Number of Pro Interviews:</p>
          <p className={styles.value}>
            {activity.participantCount} Pro Interviews
          </p>
        </div>

        <div>
          <p className={styles.label}>Short form content deliverables:</p>
          <p className={styles.value}>~{activity.shortFormVideoCount} clips</p>
        </div>

        <div>
          <p className={styles.label}>Geo Targeted Views Guaranteed:</p>
          <p className={styles.value}>~{activity.estimatedViews}+</p>
        </div>
      </div>
    </div>
  );
};

export default EventMarketingDetailsModal;
